export default "__VITE_ASSET__Qd0S_iY1__"